import styled from "styled-components";
import theme from "../../theme";

const WrapperLoggin = styled.div`
    display: flex;
    position: relative;

    .ilustration {
        width: 75.735%;
        position: relative;
        overflow-x: hidden;
        height: 100vh;

        img {
            object-fit: cover;
            position: absolute; 
            width: 100%;
            height: 100%; 
            top: 0;
            left: 0;
        }
    } 

    .form{
        width: 22%;
        margin: 0 auto;
        margin-bottom: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .logo {
            width: 40%;
            margin-top: 110px;
            margin-bottom: 50px;
        }

        .title {
            font-family: ${theme.fontFamily.bold};
            font-size: 1.2rem;
            margin-bottom: 30px;
        }
 
        .reset-password{
            color: ${theme.fontColor.green};
            font-family: ${theme.fontFamily.medium};
            font-size: .95rem;
            margin-bottom: 10px;
            cursor: pointer;
        }

        .login-button {
            padding: 8px 0;
            width: 100%;
            border-radius: 100px;
            color: #fffffe;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            margin-bottom: 15px;
            font-size: .835rem;

            svg {
                font-size: 25px;
                margin-right: 7px;
            }

            span {
                font-weight: 600;
                margin-top: 2px;
            }

            &.facebook {
                background-color: #17559e;
            }
            &.google {
                background-color: #0086f9;
            }
        }

        .separator{
            border-top: 1px solid #88b7c0;
            margin: 30px 0px;
            width: 100%;
            position: relative;
            display: flex;
            justify-content: center;

            span {
                position: absolute;
                padding: 0 15px;
                background-color: white;
                transform: translateY(-13px);
                color: #88b7c0;
            }
        }

        .form-item{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 2px;
            margin-bottom: 25px;
            width: 100%;

            span {
                color: ${theme.fontColor.green};
                font-weight: 600;
                user-select: none;
                font-size: .9rem;
                margin-left: 15px;
            }

            input {
                border: 1px solid black;
                outline: none;
                width: calc(100% - 30px);
                border-radius: 100px;
                padding: 9px 15px;
                border: 1px solid ${theme.backgroundColor.black9};
                font-size: 1.1rem;
            }

            .input-container {
                display: flex;
                align-items: center;
                border: 1px solid black;
                outline: none;
                width: calc(100% - 10px);
                border-radius: 100px;
                padding: 1px 5px;
                border: 1px solid ${theme.backgroundColor.black9};
                font-size: 1.1rem;

                input {
                    border: none;
                }

                svg {
                    cursor: pointer;
                    margin-right: 10px;
                }
            }

            
        }

        .button{
            cursor: pointer;
            width: 60%;
            text-align: center;
            padding: 5px 0px;
            margin-bottom: 15px;
            font-weight: 600;
            color: white;
            background-color: ${theme.backgroundColor.green};
            border-radius: 100px;
            color: white;
        }

        .message {
            text-align: center;
            font-size: .95rem;
        }

        .feedback {
            color: #e60000 !important;
        }

        .have-account {
            margin-top: 10px;
            color: #111;
            font-size: .9rem;

            strong {
                color: ${theme.fontColor.green};
                cursor: pointer;

            }
        }
    }

    @media (max-width: ${theme.breackpoint.mobile_2}) {
        
        .ilustration {
            width: 100%;
            position: absolute;
            z-index: 1;
        }

        .form {
            width: 75%;
            padding: 20px 5%;
            border-radius: 10px;
            z-index: 3;
            background-color: rgba(255,255,255, .90);
            margin-top: 50px;

            .logo {
                margin-top: 0px;
            }

            .separator {
                border-top: 1px solid rgba(191, 191, 191, .40);

                span {
                    background-color: rgba(235, 235, 235, .50);

                }
            }
        }
    }
    
    @media (max-width: ${theme.breackpoint.tabletsAndSmallScreens}) and (min-width: ${theme.breackpoint.mobile_2}) {
        
        .ilustration {
            width: 100%;
            position: absolute;
            z-index: 1;
        }

        .form {
            width: 75%;
            padding: 20px 5%;
            border-radius: 10px;
            z-index: 3;
            background-color: rgba(255,255,255, .90);
            margin-top: 50px;

            .logo {
                margin-top: 0px;
            }

            .separator {
                border-top: 1px solid rgba(191, 191, 191, .40);

                span {
                    background-color: rgba(235, 235, 235, .50);
                }
            }
        }
    }
    
    @media (max-width: ${theme.breackpoint.commonScreensAndLaptops}) and (min-width: ${theme.breackpoint.tabletsAndSmallScreens}) {
        .ilustration{
            width: 75%;
        }

        .form {
            width: 22%;

            .reset-password {
                font-size: .85rem;
            }

            .form-item {

                span {
                    font-size: .8rem;
                }

                input {
                    font-size: .96rem;
                }
            }

            .button {
                font-size: .95rem;
            }

            .have-account {
                font-size: .8rem;
            }

            .separator {
                font-size: .9rem;
                
                span {
                    transform: translateY(-11px);
                }
            }

            .login-button {
                font-size: .8rem;
            }
        }
    }
    
    @media (max-width: ${theme.breackpoint.largeScreens}) and (min-width: ${theme.breackpoint.commonScreensAndLaptops}) {
        
        .ilustration{
            width: 75%;
        }

        .form {
            width: 22%;

            .reset-password {
                font-size: .85rem;
            }

            .form-item {

                span {
                    font-size: .8rem;
                }

                input {
                    font-size: .96rem;
                }
            }

            .button {
                font-size: .95rem;
            }

            .have-account {
                font-size: .8rem;
            }

            .separator {
                font-size: .9rem;
                
                span {
                    transform: translateY(-11px);
                }
            }

            .login-button {
                font-size: .8rem;
            }
        }
    }
    
    
`

export default WrapperLoggin